import { render, staticRenderFns } from "./InputTextEdit.vue?vue&type=template&id=ec96d8d0&scoped=true&"
import script from "./InputTextEdit.vue?vue&type=script&lang=js&"
export * from "./InputTextEdit.vue?vue&type=script&lang=js&"
import style0 from "./InputTextEdit.vue?vue&type=style&index=0&id=ec96d8d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec96d8d0",
  null
  
)

export default component.exports